// Vue plugin для Google Analytics
import analyticsService from '@/services/analytics';

export default {
  install(app) {
    analyticsService.installAutoTracking();

    // Добавляем сервис аналитики в глобальные свойства Vue
    app.config.globalProperties.$analytics = analyticsService;
    
    // Предоставляем сервис через provide/inject
    app.provide('analytics', analyticsService);
  }
}; 
